var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.content)?_c('div',{staticClass:"guides__hero"},[_c('img',{staticClass:"app--desktop",attrs:{"src":_vm.content.banners.data[0].image,"alt":"Guides hero banner"}}),_c('img',{staticClass:"app--mobile",attrs:{"src":_vm.content.banners.data[0].mobileImage,"alt":"Guides hero banner"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }